module.exports = __webpack_public_path__ + "img/DSC.b27f7f74.png";